import Tooltip from '@/components/webComponents/Tooltip.ce.vue';
import { defineCustomElement } from 'vue';

const getTooltipWebComponent = (tooltipId) => {
  if (customElements.get(tooltipId)) {
    return customElements.get(tooltipId);
  }

  const TooltipComponent = defineCustomElement(Tooltip);

  customElements.define(tooltipId, TooltipComponent);

  return TooltipComponent;
};

export const getOrCreateTooltip = (chart, tooltipId) => {
  let tooltipEl = chart.canvas.parentNode.querySelector(tooltipId);

  if (!tooltipEl) {
    const TooltipComponent = getTooltipWebComponent(tooltipId);

    const element = new TooltipComponent({
      id: tooltipId,
    });

    tooltipEl = element;

    chart.canvas.parentNode.appendChild(tooltipEl);
  }

  return tooltipEl;
};

export const initTooltip = ({
  context, tooltipId, createLineItems, createTitle,
}) => {
  const { chart, tooltip } = context;

  const tooltipComponent = getOrCreateTooltip(chart, tooltipId);

  if (tooltip.opacity === 0) {
    // Sets visible component prop to hide
    tooltipComponent.visible = false;
    return;
  }

  // Get position
  const pos = chart.canvas.getBoundingClientRect();

  // Set props for Vue web component
  tooltipComponent.x = pos.left + window.scrollX + tooltip.caretX;
  tooltipComponent.y = pos.top + window.scrollY + tooltip.caretY;
  tooltipComponent.title = createTitle(tooltip) || '';
  tooltipComponent.lineItems = createLineItems(tooltip) || '';
  tooltipComponent.visible = true;
};
